<template>
  <div class="products-page">
    <div class="sidebar-wrapper" v-if="windowSize > 600">
      <MerchantViewSidebar
        class="sidebar"
        @selectedIndexChange="onSelectedIndexChange"
      />
    </div>
    <div v-if="index === 0" class="products-content">
      <MerchantViewDashboard
        @changeView="changeView"
        :merchantProducts="this.merchantProducts"
      />
    </div>
    <div v-if="index === 1" class="products-content">
      <MerchantUsers :merchantProducts="this.merchantProducts" />
    </div>
    <div v-else-if="index === 2" class="products-content">
      <MerchantProducts :merchantProducts="this.merchantProducts" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import MerchantViewSidebar from "./MerchantViewSidebar";
import MerchantProducts from "./MerchantProducts";
import MerchantUsers from "./MerchantUsers";
import MerchantViewDashboard from "./MerchantViewDashboard";

export default {
  name: "merchantView",
  components: {
    MerchantViewSidebar,
    MerchantProducts,
    MerchantUsers,
    MerchantViewDashboard,
  },
  data() {
    return {
      merchantProducts: [],
      windowSize: window.innerWidth,
      index: 0,
    };
  },
  methods: {
    ...mapActions(["getMerchantProducts"]),
    onSelectedIndexChange(index) {
      this.index = index;
    },
    changeView(newIndex) {
      this.index = newIndex;
    },
  },
  async mounted() {
    const credentials = {
      token: this.$route.query.accessToken,
    };
    this.merchantProducts = await this.getMerchantProducts(credentials);
  },
};
</script>

<style scoped>
.sidebar-wrapper {
  display: flex;
  flex-direction: column;
}

.sidebar {
  flex: 1;
}

.products-page {
  height: 100%;
  display: flex;
}

.products-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.no-items {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.products-row-small-screen {
  justify-content: center !important;
}
.products-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
}

.card {
  flex: 1 0 25%;
  margin-right: 0.5%;
  margin-left: 0.5%;
  margin-top: 1%;
  margin-bottom: 1%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
}

.spacer {
  max-width: 400px;
  margin: 0 0 24px 18px;
  padding: 20px 24px 24px 24px;
}

.to-clipboard {
  border: 0;
}
.form {
  padding: 5%;
}
</style>
